import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { MallHome } from './Home'
import { ProductSearch } from './Product/Search'
import { ProductList } from './Product/List'
import {ProductList as ProductCategory} from './ProductList'
import { ProductDetails } from './Product/Details'
import { ShoppingCart } from './ShoppingCart'
import { OrderConfirm } from './Order/Confirm'
import { OrderPay } from './Order/OrderPay'
import { OrderList } from './Order/List'
import { OrderDetails } from './Order/Details'
import NotMatch from '../NoMatch'
import ProductDetailsProxy from './Product/DetailsProxy'

class MallRouter extends React.PureComponent {
  render () {
    return <Switch>
      {/*临时路由*/}
      <Route path={window.PATH.MALL} component={MallHome} exact />
      <Route path={window.PATH.MALL_HOME} component={MallHome} />
      <Route path={window.PATH.MALL_PRODUCT_SEARCH} component={ProductSearch} />
      <Route path={window.PATH.MALL_PRODUCT_LIST} exact component={ProductList} />
      <Route path={window.PATH.MALL_PRODUCT_CATEGORY} exact component={ProductCategory} />
      <Route path={`${window.PATH.MALL_PRODUCT_DETAILS}/:id`} component={ProductDetails} />
      <Route path={`${window.PATH.MALL_PRODUCT_DETAILS}`} component={ProductDetailsProxy} />
      <Route path={window.PATH.MALL_SHOPPING_CART} component={ShoppingCart} />
      <Route path={window.PATH.MALL_ORDER_CONFIRM} component={OrderConfirm} />
      <Route path={`${window.PATH.MALL_ORDER_PAY}/:orderId`} component={OrderPay} />
      <Route path={window.PATH.MALL_ORDER_LIST} component={OrderList} />
      <Route path={`${window.PATH.MALL_ORDER_DETAILS}/:orderId`} component={OrderDetails} />
      <Route component={() => <NotMatch forwardURL={window.PATH.MALL} />} />
    </Switch>
  }
}

export default MallRouter
